// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { store } from "../../../store/store";

import { createEquipmentGroup } from "../../../store/equipment/equipmentActions";

import { setUserMessageError } from "../../../store/user/userSlice";

const createdDefaultGroups = new Set();

export async function facilityLoader() {
  const state = store.getState();

  const companyUuid = state.companies?.company?.company_uuid;

  if (!companyUuid) {
    // Store the last companyUuid to detect company change in shouldRevalidate
    facilityLoader.lastCompanyUuid = null;
    return null;
  }

  const studioUuid = state.studio?.studio?.studio_uuid;
  const companyEquipmentGroups = state.equipment?.equipmentGroups || [];
  const errorCompanyEquipmentGroups = state.equipment?.error?.equipmentGroups;

  if (!studioUuid) {
    store.dispatch(
      setUserMessageError({
        type: "critical",
        message:
          "No studio selected. Please select a studio to load facility data.",
      }),
    );
    return null;
  }

  if (createdDefaultGroups.has(studioUuid)) {
    return null;
  }

  const hasDefaultGroup = companyEquipmentGroups.find(
    (group) => group.name === String(studioUuid),
  );

  if (!hasDefaultGroup && !errorCompanyEquipmentGroups) {
    // mark BEFORE dispatch to prevent race conditions
    createdDefaultGroups.add(studioUuid);

    await store.dispatch(
      createEquipmentGroup({
        name: String(studioUuid),
        company_uuid: companyUuid,
        studio_uuid: studioUuid,
      }),
    );
  }

  return null;
}
